import { createContext, useContext, useEffect } from "react";

export const BreadcrumbContext = createContext(null);

/**
 * Pages call this to override the Navbar's auto-derived breadcrumb trail
 * with their own (e.g. to add dynamic segments like a customer name).
 * `items` is an array of { label, to? } — omit `to` on the last (current) item.
 * Resets to the auto-derived trail when the page unmounts.
 */
export function useSetBreadcrumb(items) {
  const ctx = useContext(BreadcrumbContext);
  const key = JSON.stringify(items);

  useEffect(() => {
    if (!ctx) return;
    ctx.setBreadcrumb(items);
    return () => ctx.setBreadcrumb(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
